interface LoadingInterface {
  text: string;
}

export const LoadingPage = ({ text }: LoadingInterface) => {
  return (
    <div className="absolute w-full h-full loading-page">
      <div className="loading-body">
        <span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </span>
        <div className="loading-base">
          <span></span>
          <div className="loading-face"></div>
        </div>
      </div>
      <h1 className="loading">{text}</h1>
    </div>
  );
};
